import { z } from 'zod'

import { DateZod } from '../date-zod'

export const PiloteBackgroundCheckStatusZod = z.enum([
  'COMPLETE_REFUSAL',
  'ACCEPT_ESCORT',
  'ACCEPT_PARTNER',
  'COMPLETE_ACCEPTANCE',
  'PRELIMINARY_ACCEPTANCE',
])
export type PiloteBackgroundCheckStatus = z.infer<typeof PiloteBackgroundCheckStatusZod>

export const PiloteGenderZod = z.enum(['Male', 'Female', 'NonBinary'])
export type PiloteGender = z.infer<typeof PiloteGenderZod>

export const GENDER_BY_PILOTE_GENDER = {
  Female: 'female',
  NonBinary: 'nonBinary',
  Male: 'male',
} as const satisfies Record<PiloteGender, 'male' | 'female' | 'nonBinary'>

export const PilotePersonRecordZod = z.object({
  id: z.number(),
  code: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  is_unused: z.coerce
    .boolean()
    .nullish()
    .transform((value) => value ?? false),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  cell_number: z.string().nullable(),
  home_number: z.string().nullable(),
  office_number: z.string().nullable(),
  gender: PiloteGenderZod,
  birth_day: DateZod,
  background_check_status: PiloteBackgroundCheckStatusZod.nullable(),
  background_check_date: DateZod.nullable(),
})

export const PilotePersonCompleteRecordZod = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  gender: PiloteGenderZod,
  email: z.string(),
  birth_day: DateZod,
  cell_number: z.string().nullable(),
  street_address: z.string(),
  city: z.string(),
  province: z.string(),
  postal_code: z.string(),
  driver_license_number: z.string().nullable(),
  driver_license_expiration: DateZod.nullable(),
  is_manual_driver: z.coerce.boolean().nullable(),
  is_unused: z.coerce.boolean().nullable(),
  insurance_company_name: z.string().nullable(),
  insurance_policy_number: z.string().nullable(),
  insurance_expiration: DateZod.nullable(),
  apartment: z.string().nullable(),
})
